// SEO配置和结构化数据管理

export const SITE_CONFIG = {
  name: "女孩的秘密",
  url: "https://girls-secret.com",
  description: "专业的女性健康管理平台，提供科学的月经周期管理、排卵期预测、安全期计算和预产期计算功能",
  author: "Girls Secret Team",
  language: "zh-CN",
  locale: "zh_CN",
  country: "CN",
  region: "CN"
};

export const SOCIAL_IMAGES = {
  home: "/og-image-home.jpg",
  cycle: "/og-image-cycle.jpg",
  pregnancy: "/og-image-pregnancy.jpg"
};

// 生成结构化数据
export function generateWebsiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": SITE_CONFIG.name,
    "url": SITE_CONFIG.url,
    "description": SITE_CONFIG.description,
    "applicationCategory": "HealthApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "CNY"
    },
    "author": {
      "@type": "Organization",
      "name": SITE_CONFIG.author
    },
    "inLanguage": SITE_CONFIG.language,
    "audience": {
      "@type": "Audience",
      "audienceType": "Women"
    },
    "featureList": [
      "月经周期管理",
      "排卵期计算",
      "安全期预测",
      "预产期计算",
      "孕期管理"
    ]
  };
}

export function generateMedicalWebPageSchema(pageType: 'cycle' | 'pregnancy') {
  const baseSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "url": `${SITE_CONFIG.url}/${pageType}`,
    "inLanguage": SITE_CONFIG.language,
    "isPartOf": {
      "@type": "WebSite",
      "name": SITE_CONFIG.name,
      "url": SITE_CONFIG.url
    },
    "author": {
      "@type": "Organization",
      "name": SITE_CONFIG.author
    },
    "reviewedBy": {
      "@type": "Organization",
      "name": "医学专家团队"
    },
    "audience": {
      "@type": "PatientsAudience",
      "audienceType": "Women"
    }
  };

  if (pageType === 'cycle') {
    return {
      ...baseSchema,
      "name": "月经周期管理 - 排卵期计算",
      "description": "科学管理月经周期，准确计算排卵期、安全期和易孕期",
      "mainContentOfPage": {
        "@type": "WebPageElement",
        "cssSelector": "main"
      },
      "specialty": {
        "@type": "MedicalSpecialty",
        "name": "妇科学"
      }
    };
  } else {
    return {
      ...baseSchema,
      "name": "预产期计算器 - 孕期管理",
      "description": "根据末次月经日期科学计算预产期、孕周、胎儿发育情况",
      "mainContentOfPage": {
        "@type": "WebPageElement",
        "cssSelector": "main"
      },
      "specialty": {
        "@type": "MedicalSpecialty",
        "name": "产科学"
      }
    };
  }
}

// 生成面包屑导航结构化数据
export function generateBreadcrumbSchema(items: Array<{name: string, url: string}>) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
}

// 生成FAQ结构化数据
export function generateFAQSchema(faqs: Array<{question: string, answer: string}>) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
}

// 生成通用meta标签
export function generateBasicMeta({
  title,
  description,
  keywords,
  url,
  image = SOCIAL_IMAGES.home
}: {
  title: string;
  description: string;
  keywords: string;
  url: string;
  image?: string;
}) {
  return [
    { title },
    { name: "description", content: description },
    { name: "keywords", content: keywords },
    { name: "robots", content: "index, follow" },
    { name: "googlebot", content: "index, follow" },
    { name: "bingbot", content: "index, follow" },
    { name: "author", content: SITE_CONFIG.author },
    { name: "language", content: SITE_CONFIG.language },
    
    // Open Graph
    { property: "og:type", content: "website" },
    { property: "og:url", content: url },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:image", content: `${SITE_CONFIG.url}${image}` },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:locale", content: SITE_CONFIG.locale },
    { property: "og:site_name", content: SITE_CONFIG.name },
    
    // Twitter
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: `${SITE_CONFIG.url}${image}` },
    
    // 移动端优化
    { name: "mobile-web-app-capable", content: "yes" },
    { name: "apple-mobile-web-app-capable", content: "yes" },
    { name: "format-detection", content: "telephone=no" },
  ];
}